document.addEventListener('DOMContentLoaded', function() 
{
  const rolexLightbox = document.getElementById('rolexLightbox');
  const rolexLightboxCloseButton = document.getElementById('rolexLightboxCloseButton');	
  const rolexThumbnailContainer = document.getElementById('rolexLightboxThumbnailGroup');
  const rolexLightboxThumbnails = rolexThumbnailContainer.querySelectorAll('.rolex-lightbox-thumbnail');
  const rolexLightboxCarousel = document.getElementById('rolexLightboxCarousel');
  var carouselController = new Flickity( rolexLightboxCarousel, { wrapAround: true });
  
  rolexLightboxThumbnails.forEach((rolexLightboxThumbnail, index) => 
  {
    rolexLightboxThumbnail.addEventListener('click', () => 
    {
      carouselController.select( index, true, true );
      rolexLightbox.classList.remove('rolex-conceal-lightbox');
      rolexLightbox.classList.add('rolex-reveal-lightbox');
    });
  });	

  rolexLightboxCloseButton.addEventListener('click', () => 
  {
    rolexLightbox.classList.remove('rolex-reveal-lightbox');
    rolexLightbox.classList.add('rolex-conceal-lightbox');
  });
});	